"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CreateWorkManualDescription = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "Before registering a work, the first step is to search The MLC database to ensure the work does not already exist."),
    react_1.default.createElement("p", null,
        "Enter the two required search criteria below, then click ",
        react_1.default.createElement("strong", null, " Search. ")),
    react_1.default.createElement("br", null),
    react_1.default.createElement("p", null,
        "If your work does not appear in the search results, click the",
        react_1.default.createElement("strong", null, " Create New Work "),
        " button to continue with registration."),
    react_1.default.createElement("br", null),
    react_1.default.createElement("p", null,
        "If you do locate your work in the search results, click on the work, then on the next page, click the",
        ' ',
        react_1.default.createElement("strong", null, "Claim shares on this work"),
        " button.")));
exports.default = CreateWorkManualDescription;
